export default __webpack_public_path__ + "static/media/editing-task-blue.f37892c1.svg";